import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsListCreation from './SettingsListCreation';

function CustomListsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Custom Lists"
        subtitle="Create and manage custom lists"
        backTo="/settings/operations-files"
        backLabel="Operations"
        sticky
      />
      <div className="p-6">
        <SettingsListCreation />
      </div>
    </div>
  );
}

export default CustomListsPage;
